module.exports = __webpack_public_path__ + "static/media/maintenance.d1d3db28.svg";